module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messagePush"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('setting_title'),
      "selfMethod": "1"
    },
    on: {
      "leftClick": _vm.goBack
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "whiteBox"
  }, [_c('div', {
    staticClass: "switchBox"
  }, [_c('div', {
    staticClass: "swithChice"
  }, [_c('div', [_vm._v("房态图用大号字体")]), _vm._v(" "), _c('div', {
    staticClass: "swicthBox"
  }, [_c('mt-switch', {
    on: {
      "change": _vm.changeSet
    },
    model: {
      value: (_vm.bigFont),
      callback: function($$v) {
        _vm.bigFont = $$v
      },
      expression: "bigFont"
    }
  })], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6bbe8cb8","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/huanQiuPage/setting/settingHuanQiu.vue
// module id = 1801
// module chunks = 107